import { jsx as _jsx } from "react/jsx-runtime";
import { ThemeProvider } from 'styled-components';
import { useViewContainer } from './useViewContainer';
import { LayoutTemplateViewContainer } from './LayoutTemplateViewContainer';
import { SignupEmbedderOptions } from 'signup-embedder';
export const FramedViewContainer = () => {
  const {
    ViewComponent,
    viewContainerProps
  } = useViewContainer();
  const showProgressIndicator = Boolean(SignupEmbedderOptions.getOptionValue(SignupEmbedderOptions.SIGNUP_SHOW_PROGRESS_INDICATOR_OPTION));

  if (!ViewComponent) {
    return null;
  }

  return /*#__PURE__*/_jsx(ThemeProvider, {
    theme: {
      embedded: true
    },
    children: /*#__PURE__*/_jsx(LayoutTemplateViewContainer, Object.assign({
      showAccountLink: false,
      showLogo: false,
      showProgressIndicator: showProgressIndicator,
      StepViewComponent: ViewComponent
    }, viewContainerProps))
  });
};